/* src/components/YDBanners/index.js */

export { default } from './ydBannerGroup';
